import Icon from '@ant-design/icons';
import React from 'react';
const DensityComfortableIconSvg = () => React.createElement("svg", { fill: 'currentColor', height: '24', viewBox: '0 0 24 24', width: '24', xmlns: 'http://www.w3.org/2000/svg' },
    React.createElement("path", { 
        // eslint-disable-next-line max-len
        d: 'M21 4H3C2.4 4 2 4.4 2 5V11C2 11.6 2.4 12 3 12H21C21.6 12 22 11.6 22 11V5C22 4.4 21.6 4 21 4ZM21 14H3C2.4 14 2 14.4 2 15V21C2 21.6 2.4 22 3 22H21C21.6 22 22 21.6 22 21V15C22 14.4 21.6 14 21 14Z' }));
export const DensityComfortableIcon = (props) => React.createElement(Icon, Object.assign({ component: DensityComfortableIconSvg, style: {
        marginLeft: '-1px',
        marginTop: '-2px'
    } }, props));
